module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_17.254ade47.png";